export default __webpack_public_path__ + "static/media/shape2.d80f8709.svg";